var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { EOrderbookFilters } from "@frameworks/NCD/Enum/OTC";
var OrderBookPresenter = /** @class */ (function () {
    function OrderBookPresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    OrderBookPresenter.prototype.updateModifyPaymentModeDoc = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.modifyPaymentModeDoc.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.updateModifyPaymentModeDoc(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.updateModifyPaymentMode = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.modifyPaymentMode.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.updateModifyPaymentMode(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.getClientPan = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.clientPan.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.getClientPan(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.cancelOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.cancelOrder.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.cancelOrder(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.duplicateOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.duplicateOrder.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.duplicateOrder(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.getOrderBookDownloadData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.orderBookDownlaodData.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.getOrderBookDownloadData(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.uploadSuspenseDoc = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.uploadSuspenseDoc.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.uploadSuspenseDoc(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.getBankMaster = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.bankMaster.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.getBankMaster(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.refundType = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.refundType.execute({
                onSuccess: function (data) {
                    switch (String(req.category_code)) {
                        case ESubProductIds.NCD:
                            _this.actions.orderBook.updateRefundNcdType(data);
                            break;
                        case ESubProductIds.StructuredProducts:
                            _this.actions.orderBook.updateRefundType(data);
                        case ESubProductIds.Bonds:
                            _this.actions.orderBook.updateRefundType(data);
                        case ESubProductIds.UnlistedShares:
                            _this.actions.orderBook.updateRefundType(data);
                    }
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.validateInterest = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateInterest.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.validateInterest(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.validateUTR = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateUtr.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.validateUtr(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.suspenseRefund = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.suspenseRefund.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.suspenseRefund(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.refund = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.refund.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.refund(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.previewSuspenseDoc = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.previewSuspenseDoc.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.previewSuspenseDoc(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.getOrderBookTimeline = function (requestPayload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.orderBookTimeline.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.getOrderBookTimeline(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, requestPayload);
        });
    };
    OrderBookPresenter.prototype.getOrderBookDetails = function (requestPayload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.orderBookDetails.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.getOrderBookDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, requestPayload);
        });
    };
    OrderBookPresenter.prototype.getOrderBookFilter = function (requestPayload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.orderBookFilter.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.getOrderBookFilter(data);
                    switch (requestPayload.filter_type) {
                        case EOrderbookFilters.Status:
                            return _this.actions.orderBook.getStatusFilters(data);
                        case EOrderbookFilters.ProductType:
                            return _this.actions.orderBook.getProductTypesFilters(data);
                        case EOrderbookFilters.ClientName:
                            return _this.actions.orderBook.getClientNameFilters(data);
                        case EOrderbookFilters.InvestmentValue:
                            return _this.actions.orderBook.getInvestmentValueFilters(data);
                    }
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, requestPayload);
        });
    };
    OrderBookPresenter.prototype.getOrderBookResendConsent = function (requestPayload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.orderBookResendConsent.execute({
                onSuccess: function (data) {
                    _this.actions.orderBook.getOrderBookResendConsent(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, requestPayload);
        });
    };
    OrderBookPresenter.prototype.getOrderBookTable = function (req) {
        var _this = this;
        var isSignal = req.isSignal, newObj = __rest(req, ["isSignal"]);
        return new Promise(function (resolve, reject) {
            _this.usecase.orderBookTable.execute({
                onSuccess: function (data) {
                    switch (String(req.category_code)) {
                        case ESubProductIds.NCD:
                            if (req === null || req === void 0 ? void 0 : req.isSignal) {
                                _this.actions.orderBook.getOrderBookNcdTable(data);
                            }
                            else {
                                _this.actions.orderBook.getOrderBookTable(data);
                            }
                            break;
                        case ESubProductIds.StructuredProducts:
                            _this.actions.orderBook.getOrderBookTable(data);
                            break;
                        case ESubProductIds.Bonds:
                            _this.actions.orderBook.getOrderBookTable(data);
                            break;
                        case ESubProductIds.UnlistedShares:
                            _this.actions.orderBook.getOrderBookTable(data);
                            break;
                    }
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, newObj);
        });
    };
    return OrderBookPresenter;
}());
export default OrderBookPresenter;
